import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import VueCookie from "vue-cookie";

Vue.use(VueCookie);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
